import { Button } from "@bcc/components/ui/button";
import { Card, CardContent } from "@bcc/components/ui/card";
import { useTranslation } from "react-i18next";
import { setSkuImportStepTestId } from "./sku-import-step.utils";
import { OnboardingStepper } from "./onboarding-stepper";

export interface SkuImportStepProps {
  platform: string;
  onImport: () => void;
  onBack: () => void;
  testId?: string;
}

export function SkuImportStep({ platform, onImport, onBack, testId }: Readonly<SkuImportStepProps>) {
  const { t } = useTranslation();

  return (
    <div data-testid={testId ?? setSkuImportStepTestId("container")} className="flex flex-col gap-8">
      <OnboardingStepper currentStep={2} step2Label={t("onboarding.stepper.importProducts")} />

      <div className="grid gap-6 xl:grid-cols-[minmax(240px,280px)_minmax(0,1fr)] xl:gap-8">
        <div className="flex flex-col gap-4">
          <div>
            <h2 data-testid={setSkuImportStepTestId("heading")} className="mb-2 text-xl font-semibold text-text-primary">
              {t("onboarding.skuImport.title")}
            </h2>
            <p className="text-sm text-text-muted">{t("onboarding.skuImport.description", { platform })}</p>
          </div>
        </div>

        <Card className="min-w-0 border-border-subtle shadow-sm">
          <CardContent className="min-w-0 space-y-4 p-6">
            <div className="flex flex-wrap gap-2 border-t border-border pt-4">
              <Button data-testid={setSkuImportStepTestId("back-button")} variant="outline" onClick={onBack}>
                {t("common.back")}
              </Button>
              <Button data-testid={setSkuImportStepTestId("import-button")} onClick={onImport}>
                {t("onboarding.skuImport.importButton", { platform })}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
